var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-status",style:({
    'background-color': _vm.statusTypes[_vm.status].colorFaded,
    color: _vm.statusTypes[_vm.status].color
  })},[_vm._v(" "+_vm._s(_vm.statusTypes[_vm.status].title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }